import * as React from "react";
import { Editable } from "./editable";

interface Props {}
export const GvcEnvVars: React.FC<Props> = ({}) => {
  return <Editable />;
};

// ------------- GVC
// TODO show this warning on gvc
{
  /* Alert: Force redeployment of workloads */
}
// <NGAlert
//   type="info"
//   className="mt-4"
//   message="Any change will initiate the deployment of workloads that have the 'inheritEnv' flag enabled in any of their containers"
// />
